/**
 * Selection of `EnpalReport` (Abnahmeprotokoll), shared by the page fragment and the block
 * project-acceptance-report-data, so both read the same fields.
 */
export const ENPAL_REPORT_SELECTION = `
  completed {
    type
    value
  }
  signatureApprovalCustomer
  signatureApprovalTechnician
  signatureOperationCustomer
  signatureOperationTechnician
  scaffoldHeightInMeters
  assignmentType
  firstContractor
  secondContractor
  finalizedBy
  contact
  approvalReportState
  customerInstructionHappened
  customerInstructionHappenedState
  approvalAt
  operationAt
  systemType
  solarSystemType
  existingDamageNotes
  jobSafetyEquipmentUsed
  jobSafetyEquipmentUsedState
  jobSafetyOptionalNotes
  brickAndUkNotes
  brickAndUkInstallationType
  brickAndUkAssemblyType
  ballastRockWeight
  brickAndUkOptionalNotes
  cableAndPlugAttachedToRailState
  railsEarthed
  brickAndUkAttachment_A2
  brickAndUkA2State
  brickAndUk_B
  brickAndUkBState
  brickAndUk_D
  brickAndUkDState
  brickAndUk_F
  brickAndUkFState
  solarPanelNotes
  solarPanel_B2
  solarPanelB2State
  solarPanel_B3
  solarPanelB3State
  solarPanel_B4
  solarPanelB4State
  solarPanel_B5
  solarPanelB5State
  solarPanel_C1
  solarPanelC1State
  solarPanel_D
  solarPanelDState
  solarPanel_E1
  solarPanelE1State
  cableManagementNotes
  cableManagement_A
  cableManagement_B
  cableManagementBState
  cableManagement_C1
  cableManagementC1State
  cableManagement_C2
  cableManagementC2State
  cableManagement_C3
  cableManagementC3State
  cableManagement_Y
  cableManagementYState
  cableManagement_E
  cableManagementEState
  cableManagement_F
  cableManagementFState
  inverterNotes
  inverter_B
  inverterBState
  inverter_D1
  inverterD1State
  inverter_D2
  inverterD2State
  inverter_E
  inverterEState
  inverter_F5
  inverterF5State
  inverter_G
  inverterGState
  inverter_I
  inverterIState
  storageInstalled
  storageInstalledState
  storageNotes
  storage_A
  storageAState
  storage_E
  storageEState
  storage_G
  storageGState
  potentialNotes
  equipotentialBusBar_A1
  equipotentialBusBarA1State
  equipotentialBusBar_B
  equipotentialBusBarBState
  equipotentialBusBar_C
  equipotentialBusBarCState
  electricMeterNotes
  measurementNotes
  monitoringNotes
  electricMeter_B1
  electricMeterB1State
  electricMeter_B2
  electricMeterB2State
  electricMeter_B3
  electricMeterB3State
  electricMeter_C
  electricMeterCState
  electricMeter_I
  electricMeterIState
  electricMeter_I1
  electricMeterI1State
  electricMeterConnectionType
  additionalImagesNotes
  additionalImagesEnpalNotes
  journalMeasurementsStringCount
  journalMeasurements_B
  journalMeasurementsBState
  journalMeasurements_C1
  journalMeasurements_C
  journalMeasurementsCState
  tidiness_A
  tidinessAState
  tidiness_B
  tidinessBState
  electricMeterChange_1
  electricMeterChange1State
  electricMeterChange_2
  electricMeterChange_3
  electricMeterChange_4
  electricMeterChange4State
  electricMeterChange_5
  electricMeterChange_6
  electricMeterChange_7
  electricMeterChange7State
  electricMeterChange_9
  electricMeterChange_10
  electricMeterChange_11
  electricMeterChange_12
  electricMeterChange_13
  electricMeterChange_14
  electricMeterChange_15
  electricMeterChange15State
  electricMeterChange_16
  electricMeterChange16State
  electricMeterChange_17
  electricMeterChange_18
  electricMeterChange18State
  electricMeterChange_19
  electricMeterChange_20
  electricMeterChange20State
  electricMeterChange_21
  electricMeterChangeAt
  electricMeterHasBeenChanged
  electricMeterHasBeenChangedState
  systemPowerOn_1
  systemPowerOn_2
  systemPowerOn_3
  systemPowerOn_4
  systemPowerOn_5
  scaffoldAttachment {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  uploadedSignatureApprovalCustomer {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  uploadedSignatureApprovalTechnician {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  uploadedSignatureOperationCustomer {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  uploadedSignatureOperationTechnician {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  damageAttachments {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_X {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_A {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_C1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_C1_2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_C1_3 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_E {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_G {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  brickAndUkAttachment_H {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachment_A {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachment_B1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachments_C {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachments_E1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachments_E2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachment_F {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  solarPanelAttachment_G {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  cableManagementAttachment_D {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  cableManagementAttachment_X {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_A {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_B {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_C {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_D {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_F {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachmentsAdditional_F {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_G2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  inverterAttachment_H {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_B1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_B2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_C1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_C2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_D {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachments_D1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_F {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  storageAttachment_H {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  equipotentialBusBarAttachment_A {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  equipotentialBusBarAttachment_A2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  equipotentialBusBarAttachment_B1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterAttachment_B {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterAttachment_D {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterAttachment_E {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterAttachment_H {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterAttachment_J {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterAttachment_K {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  additionalImageAttachments {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  journalMeasurementsAttachment_A {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterChangeAttachment_1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterChangeAttachments_2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterChangeAttachment_3 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterChangeAttachment_4 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterChangeAttachment_5 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  electricMeterChangeAttachment_6 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  systemPowerOnAttachment_1 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  systemPowerOnAttachment_2 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
  systemPowerOnAttachment_3 {
    id
    path
    thumbnail
    filename
    displayFilename
    size
    mimetype
  }
`;
